
<template>
  <div>
    <hr class="new1">
    <div class="row">
      <p class="lead">{{$t('apartment.add_apartment_service')}}:</p>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-4 col-lg-4 mtb-10">
        <b>{{$t('apartment.apartment_services')}}</b>
        <br>
        <br>
        <b-form-select
          :options="services"
          v-model="apartment_service.service"
          @change="onSelectService"
          class="form-control max-content"
        />
      </div>
      <div class="col-sm-12 col-md-8 col-lg-8 mtb-10">
        <div class="row">
          <b>{{$t('apartment.apartment_service_details')}}</b>
          <br>
          <br>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-6">
            <b>{{$t('service.name')}}:</b> {{selectedService.name}}<br>
            <b>{{$t('service.service_code')}}:</b> {{selectedService.servicecode}}<br>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6">
            <b>{{$t('service.service_type')}}:</b> {{service_type_name}}<br>
            <b>{{$t('service.service_price')}}:</b> <span class="label label-success">{{selectedService.service_fee}} / tháng </span><br>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <button
        type="button"
        class="btn btn-labeled btn-success"
        style="margin-right: 5px;"
        @click="onAddApartmentService"
      >
        <span class="btn-label">
          <i class="glyphicon glyphicon-ok"></i>
        </span>
        {{$t('common.save')}}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
// import utils from '@/lib/utils'

export default {
  name: "ApartmentServiceInput",
  props: {
  },
  data() {
    return {
      services: [],
      apartment_service: {
        in_use: true,
        invoice_to_company_flag: false,
        apartment: null,
        service: null,
        export_invoice_to: null,
        export_invoice_to_company: null
      },
      selectedService: {
        name: "",
        servicecode: "",
        service_type: null,
        service_fee: 0
      }
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      "SERVICE_DETAILS",
      "SERVICE_TYPE_LIST",
      "APARTMENT_DETAIL_DATA",
      "GET_RESIDENT_DATA"
    ]),
    service_type_name: function() {
      return this.getServiceTypename(this.selectedService.service_type)
    }
  },
  methods: {
    ...mapActions([
      "GET_SERVICE_LIST_NO_PAGE",
      "GET_SERVICE_DETAILS",
      "GET_SERVICE_TYPE_LIST",
      "ADD_APARTMENT_SERVICE",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST"
    ]),
    getOwner() {
      let owner
      for (let i = 0; i < this.GET_RESIDENT_DATA.length; i++) {
        let resident = this.GET_RESIDENT_DATA[i]
        if (resident.isOwner) {
          owner = resident
          return owner
        }
      }
      return owner
    },
    getServiceTypename(id) {
      for (let i=0; i < this.SERVICE_TYPE_LIST.length; i++){
        let current = this.SERVICE_TYPE_LIST[i]
        if (current.id === id) {
          return current.name
        }
      }
      return id
    },
    onSelectService() {
      if (this.apartment_service.service === null ) {
        this.selectedService.name = ""
        this.selectedService.servicecode = ""
        this.selectedService.service_type = null
        this.selectedService.service_fee = 0
      } else {
        this.GET_SERVICE_DETAILS({ id: this.apartment_service.service }).then(
          function(res) {
            let result = res
            this.selectedService.name = result.name
            this.selectedService.servicecode = result.servicecode
            this.selectedService.service_type = result.service_type
            this.selectedService.service_fee = result.service_fee[0].fee_value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
          }.bind(this)
        )
      }
    },
    onAddApartmentService() {
      let owner = this.getOwner()
      this.apartment_service.apartment = this.APARTMENT_DETAIL_DATA.id
      this.apartment_service.export_invoice_to = owner ? owner.resident.id : null
      const data = this.apartment_service
      if (data.service === null) {
        this.ON_SHOW_TOAST({
          message: "Please select an service",
          styleType: "danger"
        })
        return
      }
      this.ADD_APARTMENT_SERVICE(data)
        .then(
          function(res){
            this.SUCCESS_TOAST().then(
              function(){
                this.$emit("add-apartmentservice")
                // disable newly added service in dropdown
                for (let i=0; i < this.services.length; i++){
                  let v = this.services[i]
                  if (v.value === this.apartment_service.service) {
                    v.disabled = true
                    break
                  }
                }
                // reset option in dropdown
                this.apartment_service.service = null
                this.selectedService.name = ""
                this.selectedService.servicecode = ""
                this.selectedService.service_type = null
                this.selectedService.service_fee = 0
              }.bind(this)
            )
          }.bind(this)
        )
      .catch(
        function(error){
          this.ON_SHOW_TOAST({
            message: "Please select an service",
            styleType: "danger"
          })
        }.bind(this)
      ) 
    }
  },
  mounted() {
    this.GET_SERVICE_TYPE_LIST()
    this.GET_SERVICE_LIST_NO_PAGE({feegroup: 1}).then(
      function(res) {
        let result = res.data
        let services = [
          {
            value: null,
            text: "---"
          }
        ]
        result.forEach( service => {
          let value = service.id
          let text = service.name
          let disabled = true
          // Only enable "Giữ Xe" Service For Now
          if (service.service_type === 3) {
            disabled = false
            // Disable existing service in dropdown
            for (let i=0; i < this.APARTMENT_DETAIL_DATA.apartmentservices.length; i++){
              let v = this.APARTMENT_DETAIL_DATA.apartmentservices[i]
              if (v.service === value) {
                disabled = true
                break
              }
            }
          }
          let item = {
            value: value,
            text: text,
            disabled: disabled
          }
          services.push(item)
        })
        this.services = services
      }.bind(this)
    )
    
  },
  components: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.max-content {
  width: max-content;
}

.mtb-10 {
  margin-bottom: 10px;
}

</style>


// WEBPACK FOOTER //
// src/views/Apartment/ApartmentServiceInput.vue